import React, { createContext, useState, useEffect } from 'react';

// Create the context
export const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(() => {
        const savedUser = sessionStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    const [currentPatient, setCurrentPatient] = useState(() => {
        const savedPatient = sessionStorage.getItem('currentPatient');
        return savedPatient ? JSON.parse(savedPatient) : null;
    });

    // const [outstandingBalance, setOutstandingBalance] = useState(null);

    useEffect(() => {
        if (currentUser) {
            sessionStorage.setItem('user', JSON.stringify(currentUser));
        } else {
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('sessionToken');
        }

        if (currentPatient) {
            sessionStorage.setItem('currentPatient', JSON.stringify(currentPatient));
        } else {
            sessionStorage.removeItem('currentPatient');
        }

        // const fetchOutstandingBalance = async () => {
        //     if (currentPatient) {
        //     try {
        //         const response = await fetch(`/billing/outstandingBalance?ris_patients_id=${currentPatient.ris_patients_id}`);
        //         if (response.status === 200) {
        //         const data = await response.json();
        //         // logger.log("Data from claims: " + JSON.stringify(data[0]));
        //         setOutstandingBalance(data[0].total_due);
        //         }
        //     } catch (error) {
        //         logger.error("Error fetching claims", error);
        //     }
        //     } else {
        //     // window.alert("No patient selected.");
        //     }
        // };

        // fetchOutstandingBalance();

    }, [currentUser, currentPatient]);

    // outstandingBalance, setOutstandingBalance
    return (
        <GlobalStateContext.Provider value={{ currentUser, setCurrentUser, currentPatient, setCurrentPatient }}>
            {children}
        </GlobalStateContext.Provider>
    );
};